import { ContainerModule } from 'inversify';
import { DIDependencyTypes, type ContainerModuleWhiteList } from '@kiplin/web-common/dependency-injection';
import { toastContainerModule, ToastDependencyTypes, type ToastPlacement } from '@kiplin/web-common/toast';
import { NetworkDependencyTypes } from '@shared/common/network/network.dependency-types';
import { JwtLocalStorageKey } from '@shared/common/network/domain/constant/jwt-local-storage-key.constant';
import { currentClientUserContainerModule } from '@client/entity/current-client-user/current-client-user.container-module';
import { eventContainerModule } from '@kiplin/web-common/event';
import { hostContainerModule } from '@shared/common/host/host.container-module';
import { mainLayoutContainerModule } from '@client/composition/main-layout/main-layout.container-module';
import { networkContainerModule } from '@shared/common/network/network.container-module';
import { iconContainerModule } from '@kiplin/web-common/icon';
import { customerChatbotContainerModule } from '@client/feature/customer-chatbots/customer-chatbot.container-module';
import { fileContainerModule } from '@shared/common/file/file.container-module';
import { modalContainerModule } from '@kiplin/web-common/modal';
import { navigationContainerModule } from '@kiplin/web-common/navigation';
import { errorContainerModule } from '@shared/common/error/error.container-module';
import { formContainerModule } from '@shared/common/form/form.container-module';
import { trackingContainerModule } from '@shared/common/tracking/tracking.container-module';
import { appContainerModule } from '@shared/common/app/app.container-module';
import { errorMonitoringContainerModule } from '@shared/common/error-monitoring/error-monitoring.container-module';
import { architectureCoreContainerModule } from '@kiplin/web-common/architecture-core';
import { clientSeasonContainerModule } from '@client/entity/client-season/client-season.container-module';
import { clientGameContainerModule } from '@client/entity/client-game/client-game.container-module';
import { routerContainerModule } from '@client/composition/router/router.container-module';
import { translationContainerModule } from '@kiplin/web-common/translation';
import { dynamicImportRecoveryContainerModule } from '@kiplin/web-common/dynamic-import-recovery';

const clientContainerModuleWhiteList: ContainerModuleWhiteList = new Set([
  appContainerModule,
  translationContainerModule,
  routerContainerModule,
  architectureCoreContainerModule,
  errorContainerModule,
  errorMonitoringContainerModule,
  trackingContainerModule,
  networkContainerModule,
  currentClientUserContainerModule,
  clientGameContainerModule,
  clientSeasonContainerModule,
  hostContainerModule,
  mainLayoutContainerModule,
  eventContainerModule,
  iconContainerModule,
  modalContainerModule,
  navigationContainerModule,
  dynamicImportRecoveryContainerModule,
  toastContainerModule,
  formContainerModule,
  fileContainerModule,
  customerChatbotContainerModule,
]);

export const diContainerModule = new ContainerModule(({ bind }) => {
  bind<ContainerModuleWhiteList>(DIDependencyTypes.ContainerModuleWhiteList).toConstantValue(
    clientContainerModuleWhiteList,
  );
  bind<ToastPlacement>(ToastDependencyTypes.ToastDefaultPlacement).toConstantValue('top-right');
  bind<string>(NetworkDependencyTypes.JwtLocalStorageKey).toConstantValue(JwtLocalStorageKey.Client);
});
